import { Button, Grid, Heading } from '@simplywallst/ui-core';
import Logo from '@assets/images/logo/warren-ice-cream.svg';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { useAppUpdateBoundaryTracking } from '@/features/unleash/components/AppUpdateBoundary/hooks/useAppUpdateBoundaryTracking';

export const AppUpdateBoundaryRouteFallback = () => {
  const { Track, trackEvent } = useAppUpdateBoundaryTracking();

  return (
    <Track>
      <Grid
        templateRows="minmax(50px, 200px) max-content"
        justifyContent="center"
        justifyItems="center"
        alignItems="center"
        alignContent="center"
        gap="24px"
        paddingY="x8"
        paddingX="x4"
        paddingXSm="x2"
      >
        <Logo height="100%" width="auto" />
        <Heading as="h1" textAlign="center" typography="large">
          You have an outdated version of Simply Wall St
        </Heading>
        <Grid gap="8px" templateColumns="max-content max-content">
          <Button styleType="gentleLarge" onClick={() => window.history.back()}>
            Go back
          </Button>
          <Button
            styleType="louderLarge"
            onClick={() => {
              trackEvent({
                action: 'updated',
              });
              AppUpdate.openAppStore();
            }}
          >
            Update App
          </Button>
        </Grid>
      </Grid>
    </Track>
  );
};
